import React from "react";
import "./style.css";

export const Loader: React.FC = () => {
  return (
    <span className="border-primary loader"></span>
  )
}